// Keep confirmed deletions for this session so a history response started before
// deletion, or a stale response after navigating back, cannot restore the row.
// Keys include the engine version; the same ID can exist in multiple engines.
const deletedChatsByUser = new Map();

export const rememberDeletedChat = (uid, key) => {
    if (!uid || !key) return;
    if (!deletedChatsByUser.has(uid)) deletedChatsByUser.set(uid, new Set());
    deletedChatsByUser.get(uid).add(key);
};

export const isChatDeleted = (uid, key) => deletedChatsByUser.get(uid)?.has(key) || false;
